import './_hero-carousel.scss';
import component from './hero-carousel';

export default component;
